import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useQuery } from '@apollo/client';

import PropTypes from 'prop-types';
import { useBreakpoint } from '@next-common/breakpoint';
import Header from '../../../components/Header';
import { initalAction } from '../initalAction';
import { TitelNotification } from '../../../components/TitelNotification';

import { HideInWebviewHoc } from '../../../components/HideInWebviewHoc';
import { asyncLoadArrayProzessor } from '../../jahiaPersonalize/helper/asyncLoadArrayProzessor';

/**
 * header is the redux managed state for the header
 * externals is actions provided by "unknown" redux components and used by the header
 *
 * md is a props provided by the server as mobile detect info
 * data is a props passed to the Header component (historical reason)
 *
 * @param {*} state
 */
const mapStateToProps = (state, ownProps) => {
  // search among state any component implementing 'SEARCH', and 'PUSH_HISTORY'
  const externalReducxActions = {};

  Object.keys(state).forEach((key) => {
    if (state[key].actions) {
      const { actions } = state[key];
      if (actions.nav) {
        externalReducxActions.nav = actions.nav;
      }
      if (actions.search) {
        externalReducxActions.search = actions.search;
      }
    }
  });

  let data = {};
  if (state.header.data) { // use state injected data else use from props
    data = {
      ...state.header.data,
    };
  } else if (ownProps.data) {
    // eslint-disable-next-line prefer-destructuring
    data = ownProps.data;
  }


  // header is the redux managed state for the header
  // md is provided by the server as mobile detect info
  // data is the previously data passed to the Header component
  // navandsearch is provided by the server
  return {
    header: state.header,
    externals: externalReducxActions,
    navandsearch: state.navandsearch,
    router: state.router,
    data,
    md: state.md,
  };
};

// default behavior for redux
const mapDispatchToProps = dispatch => ({
  initalAction: (...args) => dispatch(initalAction(...args)),
  dispatch,
});
//
// const HEADER_QUERY = gql`query header {
//     cart {
//       ...HeaderCart
//     }
//     profile {
//       ...HeaderProfile
//     }
//   }
//   ${Header.personalizedFraments.cart}
//   ${Header.personalizedFraments.profile}
// `;

const HeaderWithGraphQl = (props) => {
  let data;
  const headerModuleOnsiteJSApi = {
    onAddToCard: () => {},
  };
  const { md, mdMatchesBrowser } = useBreakpoint();
  const { PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION } = props;
  if (PERSONALIZED_QUERY) {
    PERSONALIZED_QUERY_OPTION.skip = true;
    if (mdMatchesBrowser) {
      PERSONALIZED_QUERY_OPTION.skip = md.isBot; // not run the query if we are in a Browser in a bot
    }
    const queryResult = useQuery(PERSONALIZED_QUERY, PERSONALIZED_QUERY_OPTION);
    // eslint-disable-next-line prefer-destructuring
    data = queryResult.data;
    headerModuleOnsiteJSApi.onAddToCard = () => {
      try {
        queryResult.client.cache.evict({ fieldName: 'cart' });
        queryResult.client.cache.evict({ fieldName: 'cartNotifications' });
      } catch (e) {
        console.error('onAddToCard error ', e);
      }
    };
  }
  // api integration with the Product page add to card feature
  useEffect(() => {
    window.RakutenHeaderModule = asyncLoadArrayProzessor(headerModuleOnsiteJSApi)(window.RakutenHeaderModule);
  }, []);

  let actionsTotalCount = 0;
  if (data && data.profile && data.profile.actionsTotalCount) {
    // eslint-disable-next-line prefer-destructuring
    actionsTotalCount = data.profile.actionsTotalCount;
  }

  return (
    <>
      <TitelNotification actionsTotalCount={actionsTotalCount} />
      <Header {...props} md={md} mdMatchesBrowser={mdMatchesBrowser} personalized={data} />
    </>
  );
};

HeaderWithGraphQl.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  PERSONALIZED_QUERY: PropTypes.any,
  PERSONALIZED_QUERY_OPTION: PropTypes.shape({
    ssr: PropTypes.bool,
    skip: PropTypes.bool,
  }),
};

HeaderWithGraphQl.defaultProps = {
  PERSONALIZED_QUERY: null,
  PERSONALIZED_QUERY_OPTION: {
    ssr: false,
    skip: true,
  },
};

// TODO make header component injectable HOC
const ConnectedHeader = HideInWebviewHoc(
  connect(mapStateToProps, mapDispatchToProps)(
    React.memo(HeaderWithGraphQl),
  ),
);

ConnectedHeader.ssr = true;
ConnectedHeader.personalizedFraments = Header.personalizedFraments;
export default ConnectedHeader;
